const secretID = {
    generate: function () {
        const length = 12;
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        localStorage.setItem("secretID", result);

        return result;
    },
    get: function () {
        return localStorage.getItem("secretID");
    }
};

export default secretID